import { Colors, Lightning, Utils } from '@lightningjs/sdk'

export default class MenuItem extends Lightning.Component {
  static _template() {
    return {
      w: 465,
      h: 90,
      BgBar: { w: 0, h: 90, x: 465, mountX: 1, rect: true, color: Colors('lBlue').get() },
      MenuIcon: { x: 95, w: 46, h: 46, y: 45, mountY: 0.5, src: this.bindProp('menuIcon') },
      Label: {
        x: 170,
        w: 280,
        h: 36,
        y: 24,
        color: this.bindProp('labelColor'),
        text: {
          text: this.bindProp('menuLabel'),
          verticalAlign: 'middle',
          fontFace: this.bindProp('labelFont'),
          fontSize: 24,
          lineHeight: 36,
        },
      },
    }
  }

  _construct() {
    this._padding = 0
    this._selected = false
  }

  set item(obj) {
    this._item = obj

    if (this.active) {
      this._update()
    }
  }

  get item() {
    return this._item
  }

  _init() {
    this.patch({
      labelFont: 'OpenSansRegular',
      labelColor: Colors('lBlue').get(),
    })
  }

  _firstActive() {
    this._update()
  }

  static get height() {
    return 90
  }

  static get width() {
    return 465
  }

  _update() {
    const { icon, label: menuLabel } = this._item

    this.patch({
      Equalizer: { visible: false },
      menuIcon: Utils.asset(`images/menu/${icon}.png`),
      menuLabel,
      labelFont: 'OpenSansRegular',
      labelColor: Colors('lBlue').get(),
    })
  }

  _focus() {
    this.patch({
      BgBar: {
        smooth: { w: [465, { duration: 0.3 }] },
      },
      smooth: {
        labelColor: [Colors('white').get(), { duration: 0.3 }],
      },
      labelFont: 'OpenSansBold',
      menuIcon: Utils.asset(`images/menu/${this._item.icon}F.png`),
    })
  }

  _unfocus() {
    this.patch({
      BgBar: {
        smooth: { w: [0, { duration: 0.3 }] },
      },
      smooth: {
        labelColor: [Colors('lBlue').get(), { duration: 0.3 }],
      },
      labelFont: 'OpenSansRegular',
      menuIcon: Utils.asset(`images/menu/${this._item.icon}.png`),
    })
  }
}
